import { Component, HostBinding, Input, Output, EventEmitter, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { ViewportScroller } from '@angular/common';

import { TranslateModule } from '@ngx-translate/core';

import { ILink, SdButtonComponent, SdListComponent, SdSpyOnDirective } from '@seb/web-design-system/core';
@Component({
  selector: 'sd-anchor-bloc',
  templateUrl: './anchor-bloc.component.html',
  styleUrls: ['./anchor-bloc.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [
    SdListComponent,
    SdSpyOnDirective,
    SdButtonComponent,
    TranslateModule
  ]
})
export class SdAnchorBlocComponent {
  constructor(private viewportScroller: ViewportScroller) {}
  @Input()
  isOpened = true;

  @Input()
  links: ILink[];

  @Output()
  isOpenedChange = new EventEmitter<boolean>();

  @Output()
  chosenLink = new EventEmitter<string>();

  @Output()
  linkClicked = new EventEmitter<string>();

  @Input() class = '';
  @HostBinding('class')
  get hostClasses(): string {
    return [this.class, this.isOpened ? 'is-open' : '']
      .filter(Boolean)
      .join(' ');
  }

  toggleMenu() {
    this.isOpened = !this.isOpened;
    this.isOpenedChange.emit(this.isOpened);
  }

  selectLink(url: string, linkName: string, event: Event) {
    this.isOpened = false;
    this.isOpenedChange.emit(this.isOpened);
    event.preventDefault();
    this.viewportScroller.scrollToAnchor(url);
    this.linkClicked.emit(linkName);
  }
}
